import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  variant?: 'blocks' | 'inline';
};
export function CountdownTimer({
  variant = 'blocks'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  if (variant === 'inline') {
    return <span className="font-mono font-bold tabular-nums" aria-label="Offer countdown" data-id="element-93" data-mp="1oc8ji4rumyc9">
        {hours}:{minutes}:{seconds}
      </span>;
  }
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="mx-auto w-full max-w-md" role="timer" aria-live="off" data-id="element-94" data-mp="1ad93fliejrrp">
      <p className="mb-3 flex items-center justify-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-signal" data-id="element-95" data-mp="15ephvm7q0hzv">
        <TimerIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="34onxgeig4dd9" />
        Special offer ends in:
      </p>
      <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-97" data-mp="2zpkr8qqqc13p">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-98" data-mp="1c2rkvgluo72u" data-mpi={i}>
            <div className="flex w-20 flex-col items-center rounded-xl border-2 border-signal bg-[#1A0B0E] py-2 sm:w-24" data-id="element-99" data-mp="1h01mdumik971">
              <span className="font-mono text-4xl font-extrabold tabular-nums text-white sm:text-5xl" data-id="element-100" data-mp="123sn4t2mhvum">
                {u.value}
              </span>
              <span className="text-[11px] font-semibold uppercase tracking-wider text-[#FF8C88]" data-id="element-101" data-mp="1ur6bi2s99j34">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-mono text-3xl font-extrabold text-signal" aria-hidden="true" data-id="element-102" data-mp="1l1mtt0ga3v9u">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}